import React from 'react';

import Row from 'react-bootstrap/Row';

export default function FAQs() {

    return (
        <div className='bg-light mt-4 mb-4 p-3'>
            <Row>
                <h1>Quality Measures</h1>
            </Row>
            <Row className='mt-3 p-3'>
                <h2>Scientific Registry of Transplant Recipients (SRTR)</h2>
                <p>HealthRate is dedicated to ensuring high-quality outcomes. To support this commitment, HealthRate incorporates data from the <a href="https://www.srtr.org" target="_blank"><b>Scientific Registry of Transplant Recipients (SRTR)</b></a> into its transplant provider evaluations. Specifically, we use <a href="https://srtr.hrsa.gov/transplant-professionals/program-specific-report/program-specific-reports-psr/" target="_blank"><b>SRTR's Program-Specific Reports</b></a> to highlight key quality measures by service, such as hazard ratio, one-year graft survival, waitlist mortality, and transplant rates. These metrics provide critical context when comparing transplant providers, enabling HealthRate users to make value-driven decisions.</p>
                <p>For a deeper look at each provider's full performance and methodology, we encourage reviewing the complete reports directly on <a href="https://www.srtr.org" target="_blank"><b>SRTR.org</b></a>.</p>

                <h3 className="mt-2">What is SRTR?</h3>
                <p>The <a href="https://www.srtr.org" target="_blank"><b>Scientific Registry of Transplant Recipients (SRTR)</b></a> is a federally funded database that collects, analyzes, and publicly reports on the performance of all solid organ transplant programs and organ procurement organizations in the United States. It operates under contract with the <b>Health Resources and Services Administration (HRSA)</b> and in coordination with the <b>Organ Procurement and Transplantation Network (OPTN)</b>.</p>

                <h3 className="mt-2">How SRTR Monitors Transplant Quality</h3>
                <p>SRTR monitors transplant quality through a wide range of data-driven methods:
                    <br />
                    <ul>
                        <li><b>Program-Specific Reports (PSRs):</b> Issued twice yearly, these reports evaluate each transplant center and OPO on a range of measures such as:
                            <ul>
                                <li>One-year patient and graft survival rates</li>
                                <li>Waitlist mortality rates</li>
                                <li>Time to transplant</li>
                                <li>Transplant rates</li>
                                <li>Donor organ utilization</li>
                                <li>Center-specific risk-adjusted outcomes</li>
                            </ul>
                        </li>
                        <li><b>Risk Adjustment:</b> SRTR uses advanced statistical modeling to adjust for differences in patient characteristics, ensuring fair comparisons across centers.</li>
                        <li><b>Data Sources:</b> SRTR integrates data from the OPTN, CMS, and the National Death Index to track outcomes throughout the transplant process.</li>
                    </ul>
                </p>

                <h3 className="mt-2">Why SRTR is a Trusted Source</h3>
                <p>SRTR is a cornerstone of the U.S. transplant system, enabling transparent, data-driven evaluation of transplant outcomes and performance. Through rigorous methodology and broad accessibility, SRTR promotes accountability, informs policy, and ultimately contributes to better patient outcomes and more equitable organ allocation.</p>
                <p>SRTR is considered the gold standard for transplant quality data because it is:
                    <ul>
                        <li><b>Comprehensive:</b> It tracks every solid organ transplant in the U.S.</li>
                        <li><b>Independent and Federally Funded:</b> Ensures objectivity and credibility.</li>
                        <li><b>Publicly Accessible:</b> Patients, clinicians, payers, and researchers can all access the data.</li>
                        <li><b>Policy-Impacting:</b> SRTR data informs regulatory oversight and system-wide transplant policies.</li>
                    </ul>
                </p>


            </Row>
        </div>
    )
}
